// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: "development",
  production: false,
  releaseVersion: 'V1.2',
  connectionString: 'InstrumentationKey=13ec43e2-2d8b-461a-86da-3dd0931699d7;IngestionEndpoint=https://canadaeast-0.in.applicationinsights.azure.com/',
  applicationFullName: 'Bixi-bike-repair-app',
  appInsights: {  
    instrumentationKey: '13ec43e2-2d8b-461a-86da-3dd0931699d7'  
}  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
